/* eslint-disable import/prefer-default-export */
import { toJS } from 'mobx';

/**list & project view */
const getCountInOverview = (state) => {
  const { projectCount, reportCount, issueCount } = toJS(state.company.overview);
  return { projectCount, reportCount, issueCount };
};

const getCountInComponent = (state) => {
  const { projectCount, componentCount } = toJS(state.company.comoverview);
  return { projectCount, componentCount };
};

const getCountInSecurity = (state) => {
  const { projectCount, securityCount } = toJS(state.company.secoverview);
  return { projectCount, securityCount };
};

const getCountInLicense = (state) => {
  const { projectCount, licenseCount, litigatorCount } = toJS(state.company.licoverview);
  return { projectCount, licenseCount, litigatorCount };
};

const getCountInPolicyProject = (state) => {
  const { projectCount, policyCount } = toJS(state.company.policySum);
  return { projectCount, policyCount };
};

/**detail summary view */
const getCountInComponentSummary = (state) => {
  const { componentCount } = toJS(state.company.comDetailSummary);
  return { componentCount };
};

const getCountInSecuritySummary = (state) => {
  const { securityCount, cnvdCount } = toJS(state.company.secDetailSummary);
  return { securityCount, cnvdCount };
};

const getCountInLicenseSummary = (state) => {
  const { licenseCount, litigatorCount } = toJS(state.company.licDetailSummary);
  return { licenseCount, litigatorCount };
};

const getCountInPolicySummary = (state) => {
  const { policyCount } = toJS(state.company.policySumDetail);
  return { policyCount };
};

const getCountInPolicyRevisionSummary = (state) => {
  const { policyCount } = toJS(state.company.revisionSum);
  return { policyCount };
};

const getCountWithPathname = (pathname, state, params) => {
  let countObject = {};

  if (pathname.indexOf('overview') !== -1 && pathname.indexOf(params.idReport) === -1) {
    countObject = getCountInOverview(state);
  } else if (pathname.indexOf('component') !== -1 && pathname.indexOf(params.idReport) === -1) {
    countObject = getCountInComponent(state);
  } else if (pathname.indexOf('security') !== -1 && pathname.indexOf(params.idReport) === -1) {
    countObject = getCountInSecurity(state);
  } else if (pathname.indexOf('license') !== -1 && pathname.indexOf(params.idReport) === -1) {
    countObject = getCountInLicense(state);
  } else if (pathname.indexOf('policy') !== -1 && pathname.indexOf(params.idReport) === -1) {
    countObject = getCountInPolicyProject(state);
  } else if (pathname.indexOf('component') !== -1 && pathname.indexOf(params.idReport) !== -1) {
    countObject = getCountInComponentSummary(state);
  } else if (pathname.indexOf('security') !== -1 && pathname.indexOf(params.idReport) !== -1) {
    countObject = getCountInSecuritySummary(state);
  } else if (pathname.indexOf('license') !== -1 && pathname.indexOf(params.idReport) !== -1) {
    countObject = getCountInLicenseSummary(state);
  } else if (pathname.indexOf('policy/project') !== -1 && pathname.indexOf(params.idReport) !== -1) {
    countObject = getCountInPolicySummary(state);
  } else if (pathname.indexOf('policy/binary') !== -1 && pathname.indexOf(params.idReport) !== -1) {
    countObject = getCountInPolicyRevisionSummary(state);
  }

  return countObject;
};

export {
  getCountWithPathname,
};
